<!-- .departments -->
<div class="departments" style="height: 44px;">
    <div class="departments__body" #bodyElement>
        <div class="departments__links-wrapper" (mouseleave)="onMouseLeave()">
            <div class="departments__submenus-container" #containerElement>
                <ng-container *ngFor="let item of categories">

                    <div *ngIf="item.subcategories;" class="departments__submenu departments__submenu--type--menu"
                        [ngClass]="{'departments__submenu--open': item === hoveredItem}" #submenuElement>

                        <app-dropdown-categories [items]="item.subCategories" (itemClick)="onSubItemClick()">
                        </app-dropdown-categories>
                    </div>
                </ng-container>
            </div>
            <ul class="departments__links">
                <li *ngFor="let item of categories" class="departments__item" [ngClass]="{
                        'departments__item--menu': item.menu && item.menu.type == 'menu',
                        'departments__item--hover': item === hoveredItem
                    }" (mouseenter)="onItemMouseEnter(item)" #itemElement>

                    <ng-template #link>
                        {{ translateHelper.localize(item.name) }}
                        <app-icon *ngIf="item.subCategories" class="departments__item-arrow"
                            name="arrow-rounded-right-6x9" size="6x9"></app-icon>
                    </ng-template>

                    <!-- <a *ngIf="!item.external" class="departments__item-link" [routerLink]="'/shop/catalog/'" [queryParams]="{slug: item.seo.slug}"
                        [target]="item.target" (click)="onItemClick()" (appTouchClick)="onTouchClick($event, item)">
                        <ng-container [ngTemplateOutlet]="link"></ng-container>
                    </a> -->
                    <a *ngIf="!item.external" class="departments__item-link" [routerLink]="((sector) ? ['sector', sector] : ['/']).concat(['category',item.seo?.slug])"
                        [target]="item.target" (click)="onItemClick()" (appTouchClick)="onTouchClick($event, item)">
                        <ng-container [ngTemplateOutlet]="link"></ng-container>
                    </a>
                    <a *ngIf="item.external" class="departments__item-link" [routerLink]="((sector) ? ['sector', sector] : ['/']).concat(['category',item._id])"
                        [target]="item.target" (click)="onItemClick()" (appTouchClick)="onTouchClick($event, item)">
                        <ng-container [ngTemplateOutlet]="link"></ng-container>
                    </a>
                </li>
            </ul>
        </div>
    </div>

    <button class="departments__button" (click)="toggle()">
        <app-icon class="departments__button-icon" name="menu-18x14" size="18x14"></app-icon>
        {{'shop_by_category'|translate}}
        <app-icon class="departments__button-arrow" name="arrow-rounded-down-9x6" size="9x6"></app-icon>
    </button>
</div>
<!-- .departments / end -->
